import React, { useEffect } from "react";
import { SalesLanding } from "./pages/SalesLanding";
import { initializeMetaPixel } from "./utils/metaPixel";
export function App() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <SalesLanding data-id="element-0" data-mp="3k8jjjl4ct8pp" />;
}